
        var result = require("!!../../../../node_modules/css-loader/index.js!./cashreg-week.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/administration/cashreg-week/cashreg-week.component.css
// module id = 2477
// module chunks = 1